import { ReactNode, useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useSubscription } from "@/contexts/SubscriptionContext";
import { useBuyer } from "@/contexts/BuyerContext";

type BuyerProtectedRouteProps = {
  children: ReactNode;
  requiresSubscription?: boolean;
};

const BuyerProtectedRoute = ({ 
  children, 
  requiresSubscription = true 
}: BuyerProtectedRouteProps) => {
  const { subscriptionStatus, userType, isLoading: subscriptionLoading } = useSubscription();
  const { isBuyer } = useBuyer();
  const location = useLocation();

  // Don't restrict dashboard or profile routes
  const isAllowedRoute = location.pathname === '/buyer/dashboard' || 
                        location.pathname === '/buyer/profile';

  // If this route doesn't require subscription or is an allowed route, pass through
  if (!requiresSubscription || isAllowedRoute) {
    return <>{children}</>;
  }

  // If subscription is still loading, show loading
  if (subscriptionLoading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="text-center space-y-4">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-godyspo-gold mx-auto"></div>
          <p className="text-sm text-muted-foreground">Loading subscription status...</p>
        </div>
      </div>
    );
  }

  // Buyer access is free — no subscription gating

  return <>{children}</>;
};

export default BuyerProtectedRoute;